import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from '../../hooks/use-toast';
import { useData } from '../../context/DataContext';

export default function TrustStatsEditor() {
  const { trustStats, updateTrustStat } = useData();
  const [draft, setDraft] = useState(trustStats);
  useEffect(() => setDraft(trustStats), [trustStats]);

  const save = async (i) => {
    try {
      await updateTrustStat(i, { label: draft[i].label, value: draft[i].value });
      toast({ title: 'Saved', description: 'Trust stat updated.' });
    } catch { toast({ title: 'Could not save', variant: 'destructive' }); }
  };

  return (
    <div data-testid="admin-trust-stats">
      <h2 className="font-display text-xl font-bold text-navy">Homepage trust numbers</h2>
      <p className="text-sm text-slate-500 mb-5">Shown in the strip directly under the hero.</p>
      <div className="grid md:grid-cols-2 gap-4">
        {draft.map((s, i) => (
          <div key={i} className="rounded-2xl border border-line bg-white p-5 grid grid-cols-[1fr_1fr_auto] gap-3 items-end">
            <div><Label>Value</Label><Input data-testid={`admin-trust-value-${i}`} value={s.value} onChange={e => setDraft(d => d.map((x, j) => (j === i ? { ...x, value: e.target.value } : x)))} className="mt-1 h-10 font-mono" /></div>
            <div><Label>Label</Label><Input data-testid={`admin-trust-label-${i}`} value={s.label} onChange={e => setDraft(d => d.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} className="mt-1 h-10" /></div>
            <Button size="icon" onClick={() => save(i)} className="bg-royal hover:bg-royal-dark text-white rounded-xl" data-testid={`admin-trust-save-${i}`}><Save className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
}
